import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { commonErrorResponses, payloadEnvelope, requiredPayloadEnvelope } from '../envelope.js';
const livePlatformSchema = z.object({
    /** fleet 타깃 platform (google LoginMethod는 youtube). */
    platform: z.string(),
    /** 수집 타깃 nativeId. */
    nativeId: z.string(),
});
const linkedPlatformSchema = z.object({
    /** fleet·UI용 platform 키 (google → youtube). */
    platform: z.string(),
    /** 채널 nativeId. identity-only면 null일 수 있다. */
    nativeId: z.string().nullable(),
    /** IdP/채널 표시 이름. */
    displayName: z.string().nullable(),
    /** 수집 API capability 보유 여부. */
    hasApiCapability: z.boolean(),
    /** fleet running과 교집합이면 true. */
    collecting: z.boolean(),
});
const memberSchema = z.object({
    id: z.string(),
    email: z.string(),
    name: z.string(),
    role: z.string(),
    tier: z.string(),
    /** Subscription 행이 없으면 none. */
    subscriptionStatus: z.string(),
    /** api-capable PlatformLink ∩ fleet running. */
    livePlatforms: z.array(livePlatformSchema),
    isTempPassword: z.boolean(),
    createdAt: z.union([z.string(), z.date()]),
    updatedAt: z.union([z.string(), z.date()]),
});
const memberDetailSchema = memberSchema.extend({
    linkedPlatforms: z.array(linkedPlatformSchema),
    /** 구독 행이 있고 기간 종료 시 해지 예정이면 true. 없으면 null. */
    cancelAtPeriodEnd: z.boolean().nullable(),
    /** 선택 구독의 기간 시작. 없으면 null. */
    currentPeriodStart: z.union([z.string(), z.date()]).nullable(),
    /** 선택 구독의 기간 종료. 없으면 null. */
    currentPeriodEnd: z.union([z.string(), z.date()]).nullable(),
});
const c = initContract();
export const adminMembersContract = c.router({
    getMembers: {
        method: 'GET',
        path: '/members',
        responses: {
            200: requiredPayloadEnvelope(z.array(memberSchema)),
            ...commonErrorResponses,
        },
    },
    getMember: {
        method: 'GET',
        path: '/members/:id',
        pathParams: z.object({ id: z.string() }),
        responses: {
            200: requiredPayloadEnvelope(memberDetailSchema),
            ...commonErrorResponses,
        },
    },
    updateMemberRole: {
        method: 'PATCH',
        path: '/members/:id/role',
        pathParams: z.object({ id: z.string() }),
        body: z.object({
            role: z.string().optional(),
        }),
        responses: {
            200: requiredPayloadEnvelope(memberSchema),
            ...commonErrorResponses,
        },
    },
    deleteMember: {
        method: 'DELETE',
        path: '/members/:id',
        pathParams: z.object({ id: z.string() }),
        responses: {
            200: payloadEnvelope(z.null()),
            ...commonErrorResponses,
        },
    },
    resetMemberPassword: {
        method: 'PATCH',
        path: '/members/:id/reset-password',
        pathParams: z.object({ id: z.string() }),
        body: c.noBody(),
        responses: {
            200: requiredPayloadEnvelope(memberSchema),
            ...commonErrorResponses,
        },
    },
});
export { memberSchema, memberDetailSchema, livePlatformSchema, linkedPlatformSchema };
//# sourceMappingURL=members.contract.js.map